<template>
  <div @keyup.stop="handleKeyup">
    <VueBottomSheet
        :max-height="sheetHeight"
        :can-swipe="false"
        :overlay-click-close="false"
        :transition-duration="0.3"
        @opened="$emit('opened')"
        @closed="onClose"
        ref="bottomSheet">
      <div class="bottom-sheet-title">
        <span class="title3" v-if="type === 'userBirthInfoSelection' && userBirthInfos">사주 정보를 선택해주세요</span>
        <span class="title3" v-else-if="type === 'userBirthInfoSelection' && !userBirthInfos">사주 정보를 추가해주세요</span>
        <span class="title3" v-else>{{ getParticle(currentTitle) }} 선택해주세요</span>
        <img :src="require('@/tarot_box/pages/box_input_v2/assets/x-button-s.svg')" alt="close" @click="close"/>
      </div>
      <MultiChoiceGrid
          v-if="type === 'multiChoiceGrid'"
          v-model="selectedValue"
          :options="currentOptions"
          :title="currentTitle"
          :sub-title="currentSubTitle"
          @select="onSelect"
      />
      <TimeInput
          v-else-if="type === 'timeInput'"
          v-model="selectedValue"
          :title="currentTitle"
          :sub-title="currentSubTitle"
          @select="onSelect"
      />
      <UserBirthInfoSelection
          v-else-if="type === 'userBirthInfoSelection'"
          v-model="selectedValue"
          :sub-title="currentSubTitle"
          :user-birth-infos="userBirthInfos"
          :input-sections="inputSections"
          :current-index="currentIndex"
          @select="onUserBirthInfoSelect"
          @open-create="$emit('open-create')"
          @open-edit="handleOpenEdit"
      />
    </VueBottomSheet>
  </div>
</template>

<script>
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import multiChoiceGridDataset from "@/tarot_box/pages/box_input_v2/data/multiChoiceGridDataset.json";
import MultiChoiceGrid from '@/tarot_box/pages/box_input_v2/components/Inputs/MultiChoiceGrid.vue';
import TimeInput from '@/tarot_box/pages/box_input_v2/components/Inputs/TimeInput.vue';

import { put } from 'cox-postposition';
import UserBirthInfoSelection from "@/tarot_box/pages/box_input_v2/components/Inputs/UserBirthInfoSelection.vue";


export default {
  name: "BottomSheet",
  components: {
    UserBirthInfoSelection,
    VueBottomSheet,
    MultiChoiceGrid,
    TimeInput
  },
  props: {
    userBirthInfos: {
      type: Object,
      default: null,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    inputSections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sheetHeight: 400,
      payload: null,
      currentOptions: [],
      currentTitle: '',
      currentSubTitle: '',
      type: '',
      subType: '',
      selectedValue: null,
    };
  },
  emits: ['select', 'closed', 'opened', 'keyup', 'user-saju-select', 'open-create', 'open-edit'],
  mounted() {
    this.calculateSheetHeight();
    window.addEventListener('resize', this.calculateSheetHeight);
    window.onBackButtonClick = this.onBackButtonClick;
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateSheetHeight);
    window.onBackButtonClick = null;
  },
  methods: {
    onBackButtonClick() {
      this.close();
    },
    open(payload) {
      this.payload = payload;
      this.type = payload.inputFormType;
      this.subType = payload.inputFormSubtype;
      this.selectedValue = payload.value;
      if (payload.inputFormType === 'multiChoiceGrid') {
        const data = multiChoiceGridDataset.multiChoiceGridDatasets[payload.inputFormSubtype];
        if (data) {
          this.currentOptions = data.options;
          this.currentTitle = data.title;
          this.currentSubTitle = data.subTitle;
        } else {
          this.currentOptions = payload.options.choices;
          this.currentTitle = payload.inputFormHeaderLabel;
          this.currentSubTitle = payload.inputFormQuestion;
        }
      } else if (payload.inputFormType === 'timeInput') {
        this.currentTitle = payload.inputFormHeaderLabel;
        this.currentSubTitle = payload.inputFormQuestion;
      }
      this.$nextTick(() => {
        this.calculateSheetHeight();
        this.$nextTick(() => {
          this.$refs.bottomSheet.open();
        });
      });
    },
    calculateSheetHeight() {
      if(this.type === 'timeInput'){
        this.sheetHeight = Math.round(window.innerHeight * 0.7);
      } else if(this.type === 'multiChoiceGrid') {
        if(this.subType === 'bloodType') {
          this.sheetHeight = 400;
        } else {
          this.sheetHeight = Math.round(window.innerHeight * 0.7);
        }
      } else if(this.type === 'userBirthInfoSelection') {
        this.sheetHeight = "auto";
      } else {
        this.sheetHeight = 250;
      }
    },
    onClose() {
      this.$emit('closed');
    },
    onSelect(value) {
      this.$emit('select', {
        key: this.payload.key,
        value: value.value || value,
        inputFormType: this.payload.inputFormType,
        inputFormSubtype: this.payload.inputFormSubtype
      });
      this.close();
    },
    onUserBirthInfoSelect(infos) {
      this.$emit('user-saju-select', {
        name: infos.name,
        birth_datetime: infos.birth_datetime,
        gender: infos.gender
      });
      this.close();
    },
    getParticle(title) {
      return put(title, '을');
    },
    close() {
      try {
        this.$refs.bottomSheet.close();
      } catch (error) {
        console.warn('Failed to close bottom sheet:', error);
      }
    },
    handleKeyup(event) {
      this.$emit('keyup', event);
    },
    handleOpenEdit(id) {
      this.$emit('open-edit', id);
    }
  }
}
</script>

<style scoped>
.bottom-sheet-title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 24px 16px 24px;
  box-sizing: border-box;
  z-index: 9999;
  font-family: "SUIT Variable", sans-serif;
}


.bottom-sheet__content{
  height: auto !important;
}

:root {
  --bottom-sheet-padding: 0px;
}

</style>
